export default __webpack_public_path__ + "static/media/Planito_Calculador-02.66360f12.png";